// src/components/Sidebar.jsx
import React, { useState } from 'react'
import { Button } from 'primereact/button'
import { ChevronDown, ChevronRight, Home, Tags, Users, Gift, Settings, ClipboardList, Clock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const sections = [
  { label: 'Dashboard', icon: <Home size={16} />, to: '/promodashboard' },
  {
    label: 'Promo Creation',
    icon: <Users size={16} />,
     to: '/create'
    // children: [ { label: 'Customers',      to: '/engagement/customers' } ]
  },
//   {
//     label: 'Campaign Hub',
//     icon: <ClipboardList size={16} />,
//     children: [
//       { label: 'Coupons',     to: '/campaign/coupons' },
//       { label: 'Referrals',   to: '/campaign/referrals' },
//       { label: 'Promotions',  to: '/campaign/promotions' },
//       { label: 'Loyalty',     to: '/campaign/loyalty' },
//       { label: 'Rewards',     to: '/campaign/rewards' }
//     ]
//   },
//   { label: 'Audit log', icon: <Clock size={16} />, to: '/audit' },
]

export default function Sidebar() {
  const nav = useNavigate()
  const [openSections, setOpenSections] = useState({})

  const toggle = key =>
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }))

  return (
    <aside className="w-64 h-screen bg-[#0C1A3E] text-white shadow-xl flex flex-col">
      <div className="px-6 py-4 text-2xl font-bold border-b border-white/10">
       <img src="https://patients-stage.curebay.in/static/media/logo-white.3137d7f75284f02f8a9395f2a619bbb3.svg" alt="#"/>
      </div>

      <nav className="flex-1 overflow-auto mt-4">
        {sections.map((sec, i) => (
          <div key={i} className="px-4">
            {sec.children ? (
              <>
                <button
                  onClick={() => toggle(sec.label)}
                  className="w-full flex items-center justify-between py-2 hover:bg-white/10 rounded"
                >
                  <div className="flex items-center gap-2">
                    {sec.icon}
                    <span>{sec.label}</span>
                  </div>
                  {openSections[sec.label]
                    ? <ChevronDown size={16}/>
                    : <ChevronRight size={16}/>
                  }
                </button>
                {openSections[sec.label] && (
                  <ul className="pl-10 mt-2 space-y-1">
                    {sec.children.map((child, j) => (
                      <li key={j}>
                        <button
                          onClick={() => nav(child.to)}
                          className="w-full text-left py-1 hover:text-[#FFD700] rounded"
                        >
                          {child.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            ) : (
              <button
                onClick={() => nav(sec.to)}
                className="w-full flex items-center gap-2 py-2 hover:bg-white/10 rounded"
              >
                {sec.icon}
                <span>{sec.label}</span>
              </button>
            )}
          </div>
        ))}
      </nav>

      <div className="px-6 py-4 border-t border-white/10">
        <Button
          label="Logout"
          icon={<Settings size={16} />}
          className="p-button-text text-white justify-start hover:text-[#FFD700]"
          onClick={() => {/* your logout logic */}}
        />
      </div>
    </aside>
  )
}
